__turbopack_context__.v({
  "bannerVideo": "VideoBanner-module___o9vDG__bannerVideo",
  "btnToggleVolumen": "VideoBanner-module___o9vDG__btnToggleVolumen",
  "buttonBanner": "VideoBanner-module___o9vDG__buttonBanner",
  "buttonsBanner": "VideoBanner-module___o9vDG__buttonsBanner",
  "fadeIn": "VideoBanner-module___o9vDG__fadeIn",
  "infoBanner": "VideoBanner-module___o9vDG__infoBanner",
  "videoContainer": "VideoBanner-module___o9vDG__videoContainer",
  "videoPoster": "VideoBanner-module___o9vDG__videoPoster",
});
